module.exports = __webpack_public_path__ + "media/empty.c48a706dee.png";